module.exports = __webpack_public_path__ + "img/savanah_content_img_01.17bc246a.jpg";